// extracted by mini-css-extract-plugin
export default {"note":"textarea_note__Rn32Z","errorMessage":"textarea_errorMessage__0d4+7"};